module.exports = "/_next/static/images/game-3-fingerprint-part-1-ff2a00915898df8e40eabfc72f1e77fa.png";